export const customerResponses = [
  "No Response",
  "In Negotiation",
  "Interested",
  "Low Budget",
  "Will Visit Store",
  "Busy. Will Callback",
  "Call on Next Follow-up Date",
  "Bought",
  "Dealer",
];

export const carBrands = [
  "Abarth",
  "Acura",
  "Alfa Romeo",
  "Alpine",
  "Ariel",
  "Aston Martin",
  "Audi",
  "Bentley",
  "BMW",
  "Brabus",
  "Brilliance",
  "Bristol",
  "Bugatti",
  "Buick",
  "BYD",
  "Cadillac",
  "Callaway",
  "Caparo",
  "Caterham",
  "Changan",
  "Chery",
  "Chevrolet",
  "Chrysler",
  "Citroen",
  "Cupra",
  "Dacia",
  "Daewoo",
  "Daihatsu",
  "Daimler",
  "Datsun",
  "De Tomaso",
  "Dodge",
  "Donkervoort",
  "DS Automobiles",
  "Eagle",
  "Elemental",
  "Ferrari",
  "Fiat",
  "Fisker",
  "Ford",
  "FSO",
  "Geely",
  "Genesis",
  "Ginetta",
  "GMC",
  "Gumpert",
  "Hennessey",
  "Holden",
  "Honda",
  "Hongqi",
  "Hummer",
  "Hyundai",
  "Infiniti",
  "Innocenti",
  "Isuzu",
  "Jaguar",
  "Jeep",
  "Jensen",
  "Jiotto",
  "Karma",
  "Kia",
  "Koenigsegg",
  "Lada",
  "Lamborghini",
  "Lancia",
  "Land Rover",
  "Lexus",
  "Lincoln",
  "Lister",
  "Lexus",
  "Lotus",
  "Luxgen",
  "Mahindra",
  "Marcos",
  "Maserati",
  "Maybach",
  "Mazda",
  "McLaren",
  "Mercedes-Benz",
  "Mercury",
  "MG",
  "Microcar",
  "Mini",
  "Mitsubishi",
  "Mitsuoka",
  "Morgan",
  "Morris",
  "NIO",
  "Nissan",
  "Noble",
  "Oldsmobile",
  "Opel",
  "Packard",
  "Pagani",
  "Panoz",
  "Perodua",
  "Peugeot",
  "Pininfarina",
  "Plymouth",
  "Pontiac",
  "Porsche",
  "Proton",
  "Qoros",
  "Radical",
  "Ravon",
  "Reliant",
  "Renault",
  "Rimac",
  "Rinspeed",
  "Rivian",
  "Rolls-Royce",
  "Ronart",
  "Rover",
  "Saab",
  "SAIC",
  "Saleen",
  "Saturn",
  "Scania",
  "Scion",
  "Seat",
  "Shelby",
  "Smart",
  "Spyker",
  "SRT",
  "SsangYong",
  "SSC North America",
  "Standard",
  "Studebaker",
  "Subaru",
  "Suzuki",
  "Swallow",
  "Talbot",
  "Tata",
  "Tatra",
  "Tesla",
  "Think",
  "Toyota",
  "Tramontana",
  "Triumph",
  "TVR",
  "Ultima",
  "Vauxhall",
  "Vencer",
  "Venturi",
  "Volkswagen",
  "Volvo",
  "Vortex",
  "W Motors",
  "Wiesmann",
  "Xin Kai",
  "Yamaha",
  "Zastava",
  "Zaz",
  "Zenith",
  "Zenvo",
  "Zotye",
  "ZX Auto",
];

export const callStatuses = [
  "Call Answered",
  "Call Declined",
];

export const budgetRanges = [
  "Not Specified",
  "0 to 10 Lakhs",
  "10 to 20 Lakhs",
  "20 to 30 Lakhs",
  "30 to 40 Lakhs",
  "40 to 50 Lakhs",
  "More than 50 Lakhs",
];

export const leadStatus = [
  "Call Lead",
  "Lost Lead",
]